import { useEffect } from "react";
import SEO from "@/components/SEO";

const SORO_SRC =
  "https://app.trysoro.com/api/embed/997a018e-08fb-41da-8572-6c717ab8d034";

export default function Blog() {
  useEffect(() => {
    const existing = document.querySelector(`script[src="${SORO_SRC}"]`);
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.src = SORO_SRC;
    script.defer = true;
    document.body.appendChild(script);
    return () => script.remove();
  }, []);

  return (
    <div data-testid="blog-page">
      <SEO
        title="Blog & Insights — Hurtler Environmental"
        description="Practical, science-based guidance on mold, indoor air quality, moisture, water damage, and building science from Hurtler Environmental — independent environmental assessments across Texas."
        path="/blog"
      />
      <section className="bg-[#0F172A] text-white py-24">
        <div className="container-x max-w-5xl">
          <div className="overline text-[#F59E0B] mb-5">Insights</div>
          <h1 className="font-display text-5xl sm:text-6xl font-extrabold tracking-tight leading-[1.05]">
            The Hurtler blog.
          </h1>
          <p className="mt-8 text-lg text-white/70 max-w-2xl leading-relaxed">
            Science-based guidance on mold, indoor air quality, moisture, and water damage across Texas.
          </p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="container-x">
          <div id="soro-blog" data-testid="soro-blog-embed" className="min-h-[420px]">
            <div className="text-center py-16 border border-slate-200 rounded-2xl bg-slate-50">
              <p className="text-slate-600 text-base">New articles are on the way.</p>
              <p className="text-slate-400 text-sm mt-2">Check back soon for science-based environmental insights.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
